import { API } from "./config";

// Country API

export const fetchCountriesAPI = (params) => {
  return API.get("/country", { params })
    .then((res) => res)
    .catch((error) => error);
};

// User API

export const fetchUserInfoApi = (payload) => {
  return API.get("/employees/", {
    params: payload,
  }).then((res) => res);
};

// Menus API

export const fetchUserMenusApi = (payload) => {
  return API.get("/pmbpartner/imdlGroups?IMDLGroupOnPremSAMAccountName=" + (payload.imdlGroups || "") + "&CompanySK=" + (payload.companySk || 1))
    .then((res) => res)
    .catch((error) => error);
};